import { NgModule } from '@angular/core';
import {
	AccordionModule,
	BoxModule,
	TabsModule,
	DropdownModule,
	AlertModule,
	BoxSmallModule,
	InputGroupModule,
	InputTextModule,
	BoxInfoModule,
} from 'portalempresa';
import { NotificacionesComponent } from './components/notificaciones/notificaciones.component';
import { AngularCoreModule } from './angular-core.module';

@NgModule({
	declarations: [NotificacionesComponent],
	imports: [
		AngularCoreModule,
		AccordionModule,
		BoxModule,
		TabsModule,
		DropdownModule,
		AlertModule,
		BoxSmallModule,
		InputGroupModule,
		InputTextModule,
		BoxInfoModule,
	],
	exports: [
		AccordionModule,
		BoxModule,
		TabsModule,
		DropdownModule,
		AlertModule,
		BoxSmallModule,
		InputGroupModule,
		InputTextModule,
		BoxInfoModule,
		NotificacionesComponent,
	],
})
export class SharedModule {}
